import namespace from '@rdfjs/namespace';
const builder = namespace('https://code.described.at/');
export const strict = builder;
export const loose = builder;
